/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { filter, first } from 'rxjs/operators';
import { RemoteControlEventArgs, RemoteControlService } from '../../services/remote-control.service';
import { RestartThrottling } from 'app/modules/remote-control-ng/services/restartThrottling';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';

@Component({
  selector: 'xs-remote-control-canvas',
  templateUrl: './remote-control-canvas.component.html',
  styleUrls: ['./remote-control-canvas.component.scss']
})
export class RemoteControlCanvasComponent implements OnInit {

  @Input() supportsInput: boolean;
  @Output() onCanvasReady = new EventEmitter<void>();
  @Output() onSetFocus = new EventEmitter<any>();

  constructor(
    private remoteControlService: RemoteControlService,
    private restartThrottle: RestartThrottling
  ) { }

  ngOnInit() {
    this.remoteControlService.RemoteControlStarted.pipe(filter(result => result.isStreamingRC === false))
      .subscribe((args: RemoteControlEventArgs) => {
        this.onCanvasReady.emit();
      });
  }

  public emitSetFocus(event: any) {
    this.onSetFocus.emit(event);
  }

  public showComponent() {
    this.resetRC();
    RcContext.instance.deviceInput?.registerKeyInputListeners();
  }

  public hideComponent() {
    RcContext.instance.deviceInput?.unregisterKeyInputListeners();
  }

  resetRC() {
    const deviceContextHandler = RcContext.instance.deviceContextHandler;
    if (deviceContextHandler) {
      // We need to wait for the context to be ready to send the first restart message,
      // Otherwise required info will be missing (ie: skin dimensions)
      // If the context was ready already, then the message is sent right away
      // This also unsubscribes the observable automatically after receiving the firstg value=true
      deviceContextHandler.contextReadyForFirstRestartMessage$
        .pipe(first(isReady => isReady === true)) // receives only the first message and automatically unsubscribe once received
        .subscribe(() => {
          const transformService = RcContext.instance.deviceScreenTransformService;
          if (transformService && transformService.isAutoZoomActive()) {
            transformService.autoZoomToCurrentViewSize(true);
            this.restartThrottle.send(transformService.getScreenScale(), false, RcContext.instance)
            transformService.refreshCanvas();
          }
        });
    }
  }
}
